@if (inventoryUsage) {
  <div class="flex-fill d-flex flex-column dx-card">
    <div class="d-flex flex-row justify-content-center inventory-usage">
      Dumpsters On Site: {{ inventoryUsage.totalUsage }} of {{ inventoryUsage.totalDumpsters }} =>
      {{ inventoryUsage.usage | number : '1.2-2' }}%
    </div>
    <div class="flex-fill d-flex flex-row dx-card">
      <div class="d-flex flex-column flex-fill responsive-paddings">
        <dx-data-grid
          #dataGrid
          keyExpr="typeId"
          class="flex-fill d-flex flex-column"
          height="100px"
          [dataSource]="currentInventoryInfos"
          [showBorders]="true"
          [showRowLines]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onSelectionChanged)="onSelectionChanged($event)"
          (onRowDblClick)="rowDoubleClick($event)"
          >
          <dxi-data-grid-column dataField="name" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="availableCount" caption="Available" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="onSiteCount" caption="On Site" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="totalCount" caption="Total" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column
            dataField="usageAverage"
            caption="Usage Avg"
            [format]="{ type: 'percent', precision: 2 }"
            width="100"
          ></dxi-data-grid-column>
          <dxi-data-grid-column dataField="locationsHTML" caption="Locations" width="350" cellTemplate="htmlTemplate"></dxi-data-grid-column>
          <dxi-data-grid-column></dxi-data-grid-column>
          <div *dxTemplate="let cell of 'htmlTemplate'">
            <span [innerHTML]="cell.text"></span>
          </div>
          <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
          <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
          <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
          <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
          <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="current-inventory-infos-grid"></dxo-data-grid-state-storing>
          <div *dxTemplate="let data of 'toolbarButtons'"></div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (currentInventoryInfos) {
              <span class="me-3">
                <strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong>
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
      <div class="d-flex flex-column flex-fill responsive-paddings">
        <dx-data-grid
          #inventoryProjectionsdataGrid
          keyExpr="startDate"
          class="flex-fill d-flex flex-column"
          [dataSource]="inventoryProjections"
          height="100px"
          [showBorders]="true"
          [showRowLines]="true"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          >
          <dxi-data-grid-column dataField="start" caption="Date" format="longDate" width="230"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="additions" caption="Additions" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="subtractions" caption="Subtractions" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column dataField="estimatedAvailable" caption="Est. Available" width="100"></dxi-data-grid-column>
          <dxi-data-grid-column></dxi-data-grid-column>
          <div *dxTemplate="let cell of 'htmlTemplate'">
            <span [innerHTML]="cell.text"></span>
          </div>
          <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
          <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
          <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
          <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
          <dxo-data-grid-state-storing [enabled]="true" type="localStorage" storageKey="current-inventory-proj-infos-grid"></dxo-data-grid-state-storing>
          <div *dxTemplate="let data of 'toolbarButtons'"></div>
          <div *dxTemplate="let data of 'toolbarText'">
            @if (inventoryProjections) {
              <span class="me-3">
                <strong>{{ inventoryProjectionsdataGrid.instance.totalCount() + ' days' }}</strong>
              </span>
            }
          </div>
        </dx-data-grid>
      </div>
    </div>
  </div>
}
